/** ISO YYYY-MM-DD → DD-MM-YYYY for file names (no slashes). */
export function formatDateUkForFileName(iso: string | undefined | null): string {
  if (!iso) return '';
  const isoMatch = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, y, m, d] = isoMatch;
    return `${d}-${m}-${y}`;
  }
  const ukSlash = String(iso).match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (ukSlash) {
    const [, d, m, y] = ukSlash;
    return `${d}-${m}-${y}`;
  }
  const ukDash = String(iso).match(/^(\d{2})-(\d{2})-(\d{4})/);
  if (ukDash) return `${ukDash[1]}-${ukDash[2]}-${ukDash[3]}`;
  return String(iso).replace(/[<>:"/\\|?*]+/g, '-');
}

/** Display & sort — ISO YYYY-MM-DD → DD/MM/YYYY */
export function formatDateUk(iso: string | undefined | null): string {
  if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso || '—';
  const [y, m, d] = iso.split(/[-T]/).map(Number);
  const dd = String(d).padStart(2, '0');
  const mm = String(m).padStart(2, '0');
  return `${dd}/${mm}/${y}`;
}

/** ISO datetime → DD/MM/YYYY, HH:MM (24h, en-GB) */
export function formatDateTimeUk(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return String(iso);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(iso);
  }
}

/** Date object → DD/MM/YYYY (local calendar date) */
export function formatDateUkFromDate(date: Date): string {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const y = date.getFullYear();
  return `${dd}/${mm}/${y}`;
}

/** Date range label — DD/MM/YYYY (en-GB) */
export function formatUkDateRangeLabel(start: Date, end: Date): string {
  const startLabel = formatDateUkFromDate(start);
  const endLabel = formatDateUkFromDate(end);
  return startLabel === endLabel ? startLabel : `${startLabel} – ${endLabel}`;
}

/** Plain text — no spinner arrows (use instead of type="number" for money) */
export function parseEuroInput(s: string): number {
  const t = s.trim().replace(/€/g, '').replace(/\s/g, '').replace(/,/g, '.');
  if (t === '') return 0;
  const n = Number(t);
  return Number.isFinite(n) ? n : 0;
}

/** DD/MM/YYYY → ISO date YYYY-MM-DD */
export function parseUkDateToIso(value: string): string | null {
  const t = value.trim();
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(t);
  if (!match) return null;
  const [, dd, mm, yyyy] = match;
  return `${yyyy}-${mm}-${dd}`;
}
